var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVlc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 8.76c-1.511 0-3.023.369-4.219 1.108-2.675 1.654-4.219 8.438-4.219 8.438L54.031 25.9c7.312 4.599 14.625 4.647 21.938 0l-2.532-7.594s-1.543-6.784-4.218-8.438C68.022 9.129 66.511 8.761 65 8.761zM47.281 46.15l-8.437 25.312c17.304 11.16 34.739 11.376 52.312 0L82.72 46.15c-11.912 8.86-23.725 8.888-35.438 0zM22.812 81.587 11 121.243h108l-11.813-39.656H94.531l1.688 5.063s1.401 4.523 0 5.906c-14.817 14.618-47.82 13.973-62.438-.844-1.185-1.201 0-5.062 0-5.062l1.688-5.063z",
    fill: "#FF8800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.469 81.585-1.688 5.063s-1.185 3.86 0 5.062c14.618 14.817 47.62 15.462 62.438.844 1.401-1.383 0-5.906 0-5.906l-1.688-5.063-3.375-10.125c-17.573 11.376-35.008 11.159-52.312 0zm11.812-35.437c11.713 8.888 23.526 8.86 35.438 0l-6.75-20.25c-7.313 4.647-14.625 4.599-21.938 0z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlc);
export default __webpack_public_path__ + "static/media/vlc.e5504062e51f5646d20cebff5a79cf87.svg";
export { ForwardRef as ReactComponent };